function createFloatingPanelService() {
    const closeListeners = new Set();
    const openListeners = new Set();
    const addCloseListener = (fn) => {
        if (closeListeners.has(fn)) {
            throw Error('[Floating Panel Service]: This listener is already listening to close events.');
        }
        closeListeners.add(fn);
        return () => {
            closeListeners.delete(fn);
        };
    };
    const addOpenListener = (fn) => {
        if (openListeners.has(fn)) {
            throw Error('[Floating Panel Service]: This listener is already listening to open events.');
        }
        openListeners.add(fn);
        return () => {
            openListeners.delete(fn);
        };
    };
    const close = (id) => {
        closeListeners.forEach(listener => listener(id));
    };
    const open = (id, props) => {
        openListeners.forEach(listener => listener(id, props));
    };
    return {
        addCloseListener,
        addOpenListener,
        close,
        open,
    };
}
const FloatingPanelService = createFloatingPanelService();
export { FloatingPanelService, };
//# sourceMappingURL=floating-panel-service.js.map